export const getElementHeight = (el) => {
    return new Promise((resolve, reject) => {
        const clone           = el.cloneNode(true);
        const width           = el.getBoundingClientRect().width;
        clone.style.cssText = 'position: fixed; top: 0; left: 0; overflow: auto; visibility: hidden; pointer-events: none; height: unset; max-height: unset; width: ' + width + 'px';
        clone.classList.add('cloned-element');
        document.body.append(clone);
        setTimeout(() => {
            const height = (Math.ceil(clone.getBoundingClientRect().height) + 2) + 'px';
            clone.remove();
            resolve(height);
        }, 300);
    });
}

export const debounce = function( fn, delay, context ) {
    var timeout;
    return function() {
        var args = arguments;

        context = context || this;

        clearTimeout( timeout );
        timeout = setTimeout( function() {
            timeout = null;
            fn.apply( context, args );
        }, delay );
    };
};
